<label alt="Borrar" aria-label="Borrar elemento">
  <mat-icon [ngClass]="cssClass" [routerLink]="routerLink" alt="Borrar" aria-label="Borrar elemento" aria-hidden="false"
    matTooltip="Borrar">
    delete_forever
  </mat-icon>
</label>
